import { render, staticRenderFns } from "./AppLogo.vue?vue&type=template&id=33eb3fa6&scoped=true&"
import script from "./AppLogo.vue?vue&type=script&lang=js&"
export * from "./AppLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33eb3fa6",
  null
  
)

export default component.exports